import { Text } from '@chakra-ui/react';

import hornImg from 'assets/brand/horn@2x.png';
import asBentoPage from 'common/bento/hoc/asBentoPage/asBentoPage';
import webView from 'common/webView';
import Button from 'components/_core/Button';
import Heading from 'components/_core/Heading';
import { OBCard } from 'features/Bento/components';
import OBNavigation from 'features/Onboarding/components/OBNavigation/OBNavigation';

import locales from './locales';

interface SasuCreationLandbotSuccessProps {
  onContinue: () => void;
}

/**
 * A page welcoming the user and inviting him to continue the onboarding
 */
const SasuCreationLandbotSuccess = asBentoPage<SasuCreationLandbotSuccessProps>(
  ({ Layout, onContinue }) => {
    return (
      <Layout
        nav={webView.config?.isEmbedInAppLayout ? null : <OBNavigation />}
      >
        <OBCard>
          <OBCard.Illustration src={hornImg} />

          <OBCard.Body textAlign="center">
            <Heading marginBottom="space-16" size="lg">
              {locales.title}
            </Heading>

            <Text marginBottom="space-32">{locales.body}</Text>

            <Button isExpanded onClick={onContinue}>
              {locales.cta}
            </Button>
          </OBCard.Body>
        </OBCard>
      </Layout>
    );
  },
);

export default SasuCreationLandbotSuccess;
